module.exports = __webpack_public_path__ + "static/media/burger.8b1448ec.svg";